import { CLINICARD_NAMES } from 'constants/constants';
import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:c1847e79-675f-4886-8ae2-44f772bbe7dc',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_tQCLrehqB',
  aws_user_pools_web_client_id: '2d3uqf1d4r1i4bhn26u038t82u',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://latylggszbekda5cy2upwsfjiq.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-fakeApiId123456',
  aws_cloud_logic_custom: [
    {
      name: 'userapi',
      endpoint:
        'https://wuno61t10b.execute-api.eu-west-1.amazonaws.com/sandboks',
      region: 'eu-west-1',
    },
  ],
  aws_user_files_s3_bucket: 'clinicardstorage131455-sandboks',
  aws_user_files_s3_bucket_region: 'eu-west-1',
  Auth: {
    cookieStorage: {
      domain:
        process.env.NODE_ENV === 'production'
          ? 'sandbox.clinicards.app'
          : 'localhost',
      path: '/',
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
    },
  },
};

const defaultCarepathCards = [
  'bmi',
  'prosthesis_questionnaire',
  'prepare_visit',
  'mood',
  'caregiver_strain_index',
  'vas_painscore',
  'steps',
  'photo',
  'exercises',
  'goals',
  'temperature',
  'blood_pressure',
  'heartrate',
  'saturation',
  'vas_painscore',
  'treatment_questionnaire',
  'information_questionnaire',
  'eating_questionnaire',
  'exercises_questionnaire',
  'breastfeeding',
];

export default {
  ...defaultConfigs,
  APP_TITLE: 'SANDBOX',
  APP_CODE: 'CLIN-APP-0000',
  CONTENT_LANGUAGE: 'nl',
  CONTENT_LANGUAGES: ['nl', 'en'],
  ENABLE_CE: true,
  ENABLE_PROSTHESIS_PASSPORT: true,
  ENABLE_ARTICLES: true,
  ENABLE_CAREPATH: true,
  ENABLE_MEDICAL_PROFILE: true,
  ENABLE_MANAGEMENT: true,
  ENABLE_PERSONAL_MESSAGES: true,
  ENABLE_ORGANISATION_LEVEL: true,
  ENABLE_ORGANISATION_DETAILS: true,
  ENABLE_OPERATION_PROFILE: true,
  ENABLE_INSTITUTIONS: true,
  ENABLE_STICKY_CAREPATHITEM: true,
  ENABLE_ACTIVATIONPERIOD_CAREPATHITEM: true,
  ENABLE_RANDOMISATION: true,
  INSIGHTS_GRAPH_WHITELIST: [CLINICARD_NAMES.CSI],
  AWS,
  defaultCarepathCards,
};
